// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-sidebar {
  background: var(--surface-panel-color);
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
}

.client-sidebar.collapsed {
  min-width: 40px;
  max-width: 40px;
}

.dark .client-sidebar {
  background: #1c2630;
  border-right-color: #374151;
}

.dark .client-sidebar.collapsed {
  background: #1f2937;
}

.sidebar-header {
  padding: var(--app-sidebar-header-padding, 1.5rem 1.25rem 1rem);
  border-bottom: 1px solid #e5e7eb;
  transition: border-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.dark .sidebar-header {
  border-bottom-color: #374151;
}

.sidebar-title {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 0.74rem;
  color: #6b7280;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

.dark .sidebar-header h3 {
  color: #9ca3af;
}

.sidebar-info-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid #9ca3af;
  color: #9ca3af;
  font-size: 0.75rem;
  font-weight: 600;
  font-style: italic;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
}

.sidebar-info-btn:hover {
  border-color: #6b7280;
  color: #6b7280;
  transform: scale(1.1);
}

.dark .sidebar-info-btn {
  border-color: #6b7280;
  color: #6b7280;
}

.dark .sidebar-info-btn:hover {
  border-color: #9ca3af;
  color: #9ca3af;
}

.sidebar-settings {
  position: relative;
  display: flex;
  align-items: center;
}

.sidebar-settings-btn {
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
}

.sidebar-settings-btn:hover {
  color: #4b5563;
}

.dark .sidebar-settings-btn {
  color: #9ca3af;
}

.dark .sidebar-settings-btn:hover {
  color: #f9fafb;
}

.sidebar-settings-btn svg {
  display: block;
}

.sidebar-settings-dropdown {
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 190px;
  z-index: 20;
}

.sidebar-settings-dropdown .menu-note {
  font-size: 0.75rem;
  color: #6b7280;
  margin: 0.35rem 0 0;
  line-height: 1.3;
}

.dark .sidebar-settings-dropdown .menu-note {
  color: #d1d5db;
}

.client-selector {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  padding: 1.5rem var(--app-sidebar-content-padding-inline, 1.25rem);
  gap: 1rem;
  margin-top: 0.5rem;
}

.client-selector--with-lecture {
  flex: 1 1 auto;
}

.selector-label {
  display: block;
  width: 100%;
  font-size: 1.09rem;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
}

.App-layout:not(.single-column-layout) > .client-sidebar .selector-label {
  width: 100%;
  align-self: center;
  text-align: center;
}

.dark .selector-label {
  color: #f9fafb;
}

.selector-description {
  font-size: 0.86rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6b7280;
  text-align: center;
  margin: 0;
}

.dark .selector-description {
  color: #9ca3af;
}

.client-wheel-picker {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) var(--app-wheel-control-width, 80px);
  row-gap: 1.25rem;
  column-gap: 0.5rem;
  padding-left: 0.25rem;
  align-items: center;
  position: relative;
}

.wheel-inline-row,
.random-client-row,
.custom-client-row {
  display: contents;
}

.wheel-inline-label {
  font-size: 0.98rem;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.dark .wheel-inline-label {
  color: #f9fafb;
}

.wheel-horizontal-control {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.wheel-window {
  position: relative;
  width: var(--app-wheel-control-width, 80px);
  height: var(--app-wheel-control-height, 40px);
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: var(--surface-color);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.85rem 0 0.25rem;
  font-size: 1.03rem;
  font-weight: 600;
  color: #1f2937;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.wheel-window:focus-visible {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);
}

.client-selection-cue .wheel-window,
.client-selection-cue .random-client-btn {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.client-selection-cue .wheel-window .wheel-scroll-track,
.client-selection-cue .wheel-window .wheel-scroll-btn {
  border-color: rgba(59, 130, 246, 0.46);
  background: inherit;
  color: #1d4ed8;
}

.client-selection-cue .wheel-window .wheel-scroll-btn:hover,
.client-selection-cue .wheel-window .wheel-scroll-btn:focus-visible {
  background: rgba(59, 130, 246, 0.22);
  color: #1e3a8a;
}

.client-selection-cue .random-client-btn:hover {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.5),
    0 0 38px rgba(59, 130, 246, 0.9);
}

.client-selection-cue .oars-dropdown-trigger:hover {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.dark .wheel-window {
  border-color: #4b5563;
  background: #374151;
  color: #f9fafb;
}

.dark .client-selection-cue .wheel-window,
.dark .client-selection-cue .random-client-btn {
  border-color: #60a5fa;
  background: #1e3a5f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.dark .client-selection-cue .wheel-window .wheel-scroll-track,
.dark .client-selection-cue .wheel-window .wheel-scroll-btn {
  border-color: rgba(147, 197, 253, 0.42);
  background: inherit;
  color: #dbeafe;
}

.dark .client-selection-cue .wheel-window .wheel-scroll-btn:hover,
.dark .client-selection-cue .wheel-window .wheel-scroll-btn:focus-visible {
  background: rgba(147, 197, 253, 0.18);
  color: #eff6ff;
}

.dark .client-selection-cue .random-client-btn:hover {
  border-color: #93c5fd;
  background: #23466f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.38),
    0 0 34px rgba(96, 165, 250, 0.54);
}

.dark .client-selection-cue .oars-dropdown-trigger:hover {
  border-color: #93c5fd;
  background: #23466f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.client-selection-cue .oars-dropdown-trigger,
.dark .client-selection-cue .oars-dropdown-trigger {
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.dark .client-selection-cue .oars-dropdown-trigger {
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.wheel-window-number {
  line-height: 1;
  flex: 1 1;
  text-align: center;
}

.wheel-scroll-track {
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  width: 32px;
  border-left: 1px solid #e5e7eb;
  background: var(--surface-color);
  border-radius: 0 7px 7px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wheel-scroll-btn {
  flex: 1 1;
  border: none;
  background: transparent;
  color: #4b5563;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 50%;
}

.wheel-scroll-icon {
  width: 11px;
  height: 11px;
}

.wheel-scroll-btn:first-child::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 6px;
  right: 6px;
  height: 1px;
  background: rgba(209, 213, 219, 0.8);
}

.wheel-scroll-btn:hover {
  background: rgba(59, 130, 246, 0.1);
  color: #1f2937;
}

.wheel-scroll-btn:focus-visible {
  outline: none;
  background: rgba(59, 130, 246, 0.18);
  color: #1f2937;
}

.dark .wheel-scroll-track {
  border-left-color: #4b5563;
  background: #374151;
}

.dark .wheel-scroll-btn {
  color: #d1d5db;
}

.dark .wheel-scroll-btn:first-child::after {
  background: rgba(75, 85, 99, 0.85);
}

.dark .wheel-scroll-btn:hover,
.dark .wheel-scroll-btn:focus-visible {
  background: rgba(96, 165, 250, 0.18);
  color: #f9fafb;
}

.random-client-btn {
  flex: 0 0 auto;
  display: flex;
  width: var(--app-wheel-control-width, 80px);
  height: var(--app-wheel-control-height, 40px);
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: var(--surface-color);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
  position: relative;
}

.random-client-btn:hover {
  border-color: #d1d5db;
  background-color: #f9fafb;
}

.random-client-btn:active {
  transform: scale(0.98);
}

.random-client-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.dark .random-client-btn {
  border-color: #4b5563;
  background-color: #374151;
  color: #f9fafb;
}

.dark .random-client-btn:hover {
  border-color: #6b7280;
  background-color: #4b5563;
}

.dark .random-client-btn:disabled {
  background-color: #111827;
}

.dice-icon {
  width: 24px;
  height: 24px;
}

.random-client-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(59, 130, 246, 0.4);
  border-top-color: rgba(59, 130, 246, 0.95);
  border-radius: 50%;
  animation: random-spin 0.7s linear infinite;
}

@keyframes random-spin {
  to {
    transform: rotate(360deg);
  }
}

.custom-client-btn {
  flex: 0 0 auto;
  display: flex;
  width: var(--app-wheel-control-width, 80px);
  height: var(--app-wheel-control-height, 40px);
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: var(--surface-color);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
  position: relative;
}

.custom-client-btn:hover {
  border-color: #d1d5db;
  background-color: #f9fafb;
}

.custom-client-btn:active {
  transform: scale(0.98);
}

.dark .custom-client-btn {
  border-color: #4b5563;
  background-color: #374151;
  color: #f9fafb;
}

.dark .custom-client-btn:hover {
  border-color: #6b7280;
  background-color: #4b5563;
}

.upload-icon {
  width: 24px;
  height: 24px;
}


.oars-sidebar-filters {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  padding: 1.5rem var(--app-sidebar-content-padding-inline, 1.25rem);
  gap: 1rem;
  margin-top: 0.5rem;
}

.oars-sidebar-controls {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.client-sidebar--single-column-drawer {
  --app-wheel-control-width: 72px;
  --app-wheel-control-height: 36px;
  width: 100%;
  height: 100%;
  min-height: 0;
  max-height: none;
  overflow: visible;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  overscroll-behavior: contain;
}

.client-sidebar--single-column-drawer .client-selector,
.client-sidebar--single-column-drawer .oars-sidebar-filters {
  flex: 0 0 auto;
  padding: 0;
  margin-top: 0;
  gap: 0.48rem;
  align-items: stretch;
}

.client-sidebar--single-column-drawer .oars-sidebar-filters {
  flex: 1 1 auto;
  min-height: 0;
  gap: 0;
  overflow: visible;
}

.client-sidebar--single-column-drawer .oars-sidebar-controls {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding-bottom: 0.42rem;
}

.client-sidebar--single-column-drawer .selector-label {
  width: auto;
  font-size: 1rem;
  line-height: 1.18;
  text-align: left;
  align-self: flex-start;
}

.client-sidebar--single-column-drawer .client-wheel-picker {
  padding-left: 0;
  column-gap: 0.55rem;
  row-gap: 0.5rem;
}

.client-sidebar--single-column-drawer .wheel-inline-label {
  font-size: 0.9rem;
}

.client-sidebar--single-column-drawer .wheel-window {
  padding-right: 1.62rem;
  font-size: 0.95rem;
}

.client-sidebar--single-column-drawer .wheel-scroll-track {
  width: 28px;
}

.client-sidebar--single-column-drawer .dice-icon,
.client-sidebar--single-column-drawer .upload-icon {
  width: 21px;
  height: 21px;
}

.client-sidebar--single-column-drawer .wheel-horizontal-control {
  justify-content: flex-end;
}

/* Bound the selector column so the observer stack gets a definite height to
   distribute — without it the tabs size to content and the whole stack scrolls. */
.client-sidebar--single-column-drawer .client-selector:has(.single-column-observer-tabs) {
  flex: 1 1 auto;
  min-height: 0;
}

.client-sidebar--single-column-drawer .single-column-observer-tabs {
  --single-column-observer-inline-padding: 1.05rem;
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 0;
  margin-left: calc(-1 * var(--single-column-observer-inline-padding));
  margin-right: calc(-1 * var(--single-column-observer-inline-padding));
  padding: 0.62rem var(--single-column-observer-inline-padding) 0;
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
  width: calc(100% + (2 * var(--single-column-observer-inline-padding)));
  box-sizing: border-box;
  overflow: hidden;
  overscroll-behavior: contain;
}

/* Tabs keep overflow visible so the full-bleed divider below is not clipped;
   the analytics shell clips its own body and scrolls internally instead. */
.client-sidebar--single-column-drawer .single-column-observer-tab {
  flex: 0 0 auto;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.client-sidebar--single-column-drawer .single-column-observer-tab--analytics:not(.single-column-observer-tab--collapsed) {
  flex: 1 1 auto;
}

.client-sidebar--single-column-drawer .single-column-observer-tab + .single-column-observer-tab {
  position: relative;
  padding-top: 0.72rem;
}

.client-sidebar--single-column-drawer .single-column-observer-tab + .single-column-observer-tab::before {
  content: '';
  position: absolute;
  top: 0;
  left: calc(-1 * var(--single-column-observer-inline-padding));
  right: calc(-1 * var(--single-column-observer-inline-padding));
  border-top: 1px solid rgba(148, 163, 184, 0.25);
}

.dark .client-sidebar--single-column-drawer .single-column-observer-tab + .single-column-observer-tab::before {
  border-top-color: rgba(75, 85, 99, 0.55);
}

.client-sidebar--single-column-drawer .single-column-observer-tab .wai-section,
.client-sidebar--single-column-drawer .single-column-observer-tab .in-session-analytics {
  height: auto;
  min-height: 0;
  margin-bottom: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .wai-section {
  flex: 0 0 auto;
}

/* Centre the chevron on the title row instead of baseline-aligning it to the
   "Latest" value, matching the 3-column observer tab headers. */
.client-sidebar--single-column-drawer .single-column-observer-tab .wai-panel__header {
  align-items: center;
  min-height: 24px;
}

/* Collapsed, the header has nothing below it to separate from, so its bottom
   margin just pads the tab out past the divider. */
.client-sidebar--single-column-drawer .single-column-observer-tab--collapsed .wai-panel__header {
  margin-bottom: 0;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .in-session-analytics {
  flex: 1 1 auto;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .wai-chart {
  max-height: 13rem;
  overflow: hidden;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .wai-chart__svg {
  display: block;
  width: 100%;
  height: auto;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-scroll-body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-sections {
  gap: 0.72rem;
  width: 100%;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-card {
  width: 100%;
  box-sizing: border-box;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-card-header {
  padding: 0.52rem 0.72rem;
}

.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-card-content {
  padding: 0.62rem 0.72rem;
}

.client-sidebar--single-column-drawer .single-column-session-metrics {
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 0.72rem;
  padding-top: 0.72rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: visible;
}

/* The analytics review nests the observer stack, which brings its own top
   padding — drop the metrics wrapper's so the WAI tab sits where it does
   during a live session. */
.client-sidebar--single-column-drawer .single-column-session-metrics--analytics {
  margin-top: 0;
  padding-top: 0;
}

.client-sidebar--single-column-drawer .single-column-session-metrics-scroll {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.client-sidebar--single-column-drawer .single-column-session-metrics-scroll::-webkit-scrollbar {
  display: none;
}

.client-sidebar--single-column-drawer .single-column-session-end-reason {
  border: 1px solid #d1d5db;
  border-radius: 0.65rem;
  padding: 0.72rem 0.82rem;
  background: rgba(255, 255, 255, 0.42);
}

.dark .client-sidebar--single-column-drawer .single-column-session-end-reason {
  background: rgba(15, 23, 42, 0.22);
  border-color: rgba(75, 85, 99, 0.75);
}

.client-sidebar--single-column-drawer .single-column-session-end-reason__label {
  display: block;
  color: #6b7280;
  font-size: 0.73rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
}

.dark .client-sidebar--single-column-drawer .single-column-session-end-reason__label {
  color: #9ca3af;
}

.client-sidebar--single-column-drawer .single-column-session-end-reason__text {
  margin: 0.38rem 0 0;
  color: #1f2937;
  font-size: 0.88rem;
  line-height: 1.45;
  text-align: center;
}

.dark .client-sidebar--single-column-drawer .single-column-session-end-reason__text {
  color: #e5e7eb;
}

.client-sidebar--single-column-drawer .single-column-session-metrics .download-row {
  margin-top: 0;
  padding: 0.52rem 0.55rem;
  gap: 0.28rem;
}

.client-sidebar--single-column-drawer .single-column-session-metrics .download-row-inner {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.28rem;
}

.client-sidebar--single-column-drawer .single-column-session-metrics .download-action-item {
  gap: 0.25rem;
}

.client-sidebar--single-column-drawer .single-column-session-metrics .download-label {
  font-size: 0.74rem;
}

.client-sidebar--single-column-drawer .single-column-session-metrics .download-icon-button {
  width: 1.82rem;
  height: 1.82rem;
}

.client-sidebar--single-column-drawer .single-column-session-action-dock {
  flex: 0 0 auto;
  position: relative;
  margin: auto -1.05rem -0.75rem;
  padding: 0.95rem 1.05rem 0.75rem;
  background: var(--surface-panel-color);
}

.client-sidebar--single-column-drawer .single-column-session-action-dock::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
}

.dark .client-sidebar--single-column-drawer .single-column-session-action-dock {
  background: #1c2630;
}

.dark .client-sidebar--single-column-drawer .single-column-session-action-dock::before {
  border-top-color: rgba(75, 85, 99, 0.55);
}

.client-sidebar--single-column-drawer .sidebar-lecture-video {
  display: none;
}

.client-sidebar--single-column-drawer .oars-sidebar-context-panel {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0.45rem 0 0;
  margin-top: 0.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.client-sidebar--single-column-drawer .oars-sidebar-context-panel::-webkit-scrollbar {
  display: none;
}

.client-sidebar--single-column-drawer .oars-sidebar-context-panel .analytics-header {
  margin-bottom: 0.25rem;
}

.client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-context-body {
  font-size: 0.86rem;
  line-height: 1.65;
  color: #374151;
  white-space: pre-wrap;
  word-break: break-word;
}

.dark .client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-context-body {
  color: #d1d5db;
}

.client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-action-bar {
  margin-top: 0.35rem;
}

.client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-next-exercise-wrap {
  width: min(13rem, 100%);
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll {
  flex: 1 1 auto;
  min-height: 0;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  padding-top: 0.85rem;
  padding-bottom: 0.9rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll::-webkit-scrollbar {
  display: none;
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-divider {
  flex: 0 0 auto;
  height: 0;
  margin: 0 -1.05rem;
  border-top: 1px solid transparent;
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-divider--visible {
  border-top-color: rgba(148, 163, 184, 0.25);
}

.dark .client-sidebar--single-column-drawer .oars-sidebar-feedback-divider--visible {
  border-top-color: rgba(75, 85, 99, 0.55);
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-card-content {
  min-height: 0;
  padding: 0.6rem 0.75rem 0.7rem;
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-card-header {
  padding: 0.42rem 0.75rem;
}

.oars-guidance-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  margin-left: auto;
}

.oars-guidance-expand-btn {
  display: none;
}

.client-sidebar--single-column-drawer .oars-guidance-expand-btn {
  display: inline-flex;
}

.client-sidebar--single-column-drawer .oars-guidance-expand-btn--selection-cue {
  color: #2563eb;
  filter:
    drop-shadow(0 0 4px rgba(59, 130, 246, 1))
    drop-shadow(0 0 14px rgba(59, 130, 246, 0.84))
    drop-shadow(0 0 24px rgba(59, 130, 246, 0.5));
}

.dark .client-sidebar--single-column-drawer .oars-guidance-expand-btn--selection-cue {
  color: #93c5fd;
  filter:
    drop-shadow(0 0 4px rgba(96, 165, 250, 1))
    drop-shadow(0 0 14px rgba(96, 165, 250, 0.78))
    drop-shadow(0 0 24px rgba(96, 165, 250, 0.48));
}

.oars-guidance-expanded-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  min-height: 3.35rem;
  padding: 0.85rem 3.25rem 0.85rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.dark .oars-guidance-expanded-header {
  border-bottom-color: #374151;
}

.oars-guidance-expanded-header h3 {
  margin: 0;
  color: #111827;
  font-size: 1rem;
  font-weight: 600;
}

.dark .oars-guidance-expanded-header h3 {
  color: #f9fafb;
}

.oars-guidance-expanded-close {
  top: 0.8rem;
  right: 0.8rem;
}

.oars-guidance-expanded-body {
  white-space: pre-wrap;
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-text {
  display: block;
  line-height: 1.55;
  white-space: pre-wrap;
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-sections {
  gap: 0.75rem;
}

.client-sidebar--single-column-drawer .oars-sidebar-feedback-tail {
  flex: 0 0 0.15rem;
  min-height: 0.15rem;
}

.client-sidebar--single-column-drawer .oars-sidebar-action-dock {
  flex: 0 0 auto;
  position: relative;
  margin: 0 -1.05rem -0.75rem;
  padding: 0.95rem 1.05rem 0.75rem;
  background: var(--surface-panel-color);
}

.client-sidebar--single-column-drawer .oars-sidebar-action-dock::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
}

.dark .client-sidebar--single-column-drawer .oars-sidebar-action-dock {
  background: #1c2630;
}

.dark .client-sidebar--single-column-drawer .oars-sidebar-action-dock::before {
  border-top-color: rgba(75, 85, 99, 0.55);
}

.sidebar-lecture-video {
  margin-top: auto;
  padding-top: 0.5rem;
}

.App-layout.single-column-layout .sidebar-lecture-video {
  display: none;
}

.sidebar-lecture-video-label {
  text-align: left;
  margin-bottom: 0.75rem;
}

.sidebar-lecture-video-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
  display: block;
  border: 1px solid #e5e7eb;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  padding: 0;
  cursor: pointer;
}

.sidebar-lecture-video-frame::after {
  content: '▶';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: rgba(248, 250, 252, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.45);
  color: #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  line-height: 1;
  opacity: 0;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.16);
  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  pointer-events: none;
}

.sidebar-lecture-video-frame:hover {
  border-color: #d1d5db;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
}

.sidebar-lecture-video-frame:hover::after,
.sidebar-lecture-video-frame:focus-visible::after {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

.dark .sidebar-lecture-video-frame {
  border-color: #4b5563;
}

.dark .sidebar-lecture-video-frame::after {
  background: rgba(28, 38, 48, 0.92);
  border-color: rgba(75, 85, 99, 0.85);
  color: #f8fafc;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.dark .sidebar-lecture-video-frame:hover {
  border-color: #6b7280;
  box-shadow: 0 10px 24px rgba(2, 6, 23, 0.3);
}

.sidebar-lecture-video-frame img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.sidebar-lecture-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 60000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.6);
}

.sidebar-lecture-modal-panel {
  width: min(960px, 100%);
  background: var(--surface-color);
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.32);
  overflow: hidden;
}

.sidebar-lecture-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1.25rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.3);
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.sidebar-lecture-modal-header.is-dragging { cursor: grabbing; }

.sidebar-lecture-modal-header h3 {
  margin: 0;
  font-size: 1rem;
  color: #111827;
}

.sidebar-lecture-modal-close {
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  padding: 0;
  background: transparent;
  color: #9ca3af;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.15s;
}

.sidebar-lecture-modal-close:hover {
  color: #374151;
}

.sidebar-lecture-modal-close svg {
  width: 1.1rem;
  height: 1.1rem;
}

.sidebar-lecture-modal-video {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
}

.sidebar-lecture-modal-video iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.dark .sidebar-lecture-modal-panel {
  background: #1c2630;
  border-color: #263447;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5);
}

.dark .sidebar-lecture-modal-header {
  border-bottom-color: rgba(75, 85, 99, 0.6);
}

.dark .sidebar-lecture-modal-header h3 {
  color: #f9fafb;
}

.dark .sidebar-lecture-modal-close {
  background: transparent;
  color: #6b7280;
}

.dark .sidebar-lecture-modal-close:hover {
  background: transparent;
  color: #e5e7eb;
}

.oars-skill-dropdown {
  position: relative;
}

.oars-dropdown-trigger {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.oars-dropdown-trigger:hover {
  border-color: #d1d5db;
}

.dark .oars-dropdown-trigger:hover {
  border-color: #6b7280;
  background-color: #4b5563;
}

.oars-dropdown-trigger.open,
.oars-dropdown-trigger:focus-visible {
  outline: none;
  border-color: #2563eb;
  box-shadow: none;
}

.dark .oars-dropdown-trigger.open,
.dark .oars-dropdown-trigger:focus-visible {
  border-color: #3b82f6;
  box-shadow: none;
}

.oars-dropdown-arrow {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b5563;
  pointer-events: none;
}

.dark .oars-dropdown-arrow {
  color: #d1d5db;
}

.oars-skill-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 170px;
  background: var(--surface-color);
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  z-index: 50;
  overflow: hidden;
  padding: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.dark .oars-skill-dropdown-menu {
  background: #1f2937;
  border-color: #374151;
}

.oars-skill-dropdown-option {
  width: 100%;
  padding: 0.45rem 0.65rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #374151;
  font-size: 0.8rem;
  font-weight: 500;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.oars-skill-dropdown-option:hover {
  background: #f3f4f6;
  color: #111827;
}

.oars-skill-dropdown-option.selected {
  background: rgba(37, 99, 235, 0.08);
  color: #2563eb;
  font-weight: 600;
}


.dark .oars-skill-dropdown-option {
  color: #d1d5db;
}

.dark .oars-skill-dropdown-option:hover {
  background: #374151;
  color: #f9fafb;
}

.dark .oars-skill-dropdown-option.selected {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}


.oars-skill-dropdown-option-letter {
  font-weight: 700;
  width: 1rem;
  flex-shrink: 0;
  color: #9ca3af;
}

.oars-skill-dropdown-option.selected .oars-skill-dropdown-option-letter {
  color: inherit;
}

.btc-counsellor-dropdown-menu .oars-skill-dropdown-option {
  gap: 0.55rem;
}

.btc-counsellor-dropdown-menu .oars-skill-dropdown-option-letter {
  width: 2.15rem;
}


.sidebar-loading,
.sidebar-error {
  padding: 2rem 1rem;
  text-align: center;
  color: #6e6e80;
}

.sidebar-error button {
  margin-top: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.sidebar-error button:hover {
  background-color: #2980b9;
}

@media (max-width: 768px) {
  .client-sidebar {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    height: auto;
    max-height: none;
    padding: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    overflow: visible;
  }

  .dark .client-sidebar {
    background: rgba(31, 41, 55, 0.5);
  }

  .client-sidebar.client-sidebar--single-column-drawer {
    background: transparent;
    border-radius: 0;
    height: 100%;
    min-height: 0;
    max-height: none;
    overflow: visible;
    box-shadow: none;
  }

  .dark .client-sidebar.client-sidebar--single-column-drawer {
    background: transparent;
  }

  .client-sidebar.collapsed {
    min-width: auto;
    max-width: none;
  }

  .sidebar-header {
    padding: 0.75rem 1rem;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/ClientSidebar.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0EAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;oCAEkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;;EAEE,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;;EAEE;;qCAEmC;AACrC;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE,cAAc;EACd,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mFAAmF;EACnF,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mFAAmF;EACnF,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,UAAU;EACV,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;kFACkF;AAClF;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,cAAc;EACd,aAAa;EACb,aAAa;EACb,oEAAoE;EACpE,qEAAqE;EACrE,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sEAAsE;EACtE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;2EAC2E;AAC3E;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,6DAA6D;EAC7D,8DAA8D;EAC9D,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;gEACgE;AAChE;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;mDACmD;AACnD;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd;;;iDAG+C;AACjD;;AAEA;EACE,cAAc;EACd;;;kDAGgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,wDAAwD;EACxD,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,6CAA6C;EAC7C,uHAAuH;EACvH,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,4CAA4C,gBAAgB,EAAE;;AAE9D;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;AAGA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,yCAAyC;IACzC,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;AAEF","sourcesContent":[".client-sidebar {\n  background: var(--surface-panel-color);\n  border-right: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.client-sidebar.collapsed {\n  min-width: 40px;\n  max-width: 40px;\n}\n\n.dark .client-sidebar {\n  background: #1c2630;\n  border-right-color: #374151;\n}\n\n.dark .client-sidebar.collapsed {\n  background: #1f2937;\n}\n\n.sidebar-header {\n  padding: var(--app-sidebar-header-padding, 1.5rem 1.25rem 1rem);\n  border-bottom: 1px solid #e5e7eb;\n  transition: border-color 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.dark .sidebar-header {\n  border-bottom-color: #374151;\n}\n\n.sidebar-title {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.sidebar-header h3 {\n  margin: 0;\n  font-size: 0.74rem;\n  color: #6b7280;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 1px;\n  transition: color 0.3s ease;\n}\n\n.dark .sidebar-header h3 {\n  color: #9ca3af;\n}\n\n.sidebar-info-btn {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1.5px solid #9ca3af;\n  color: #9ca3af;\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-style: italic;\n  background: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 0;\n}\n\n.sidebar-info-btn:hover {\n  border-color: #6b7280;\n  color: #6b7280;\n  transform: scale(1.1);\n}\n\n.dark .sidebar-info-btn {\n  border-color: #6b7280;\n  color: #6b7280;\n}\n\n.dark .sidebar-info-btn:hover {\n  border-color: #9ca3af;\n  color: #9ca3af;\n}\n\n.sidebar-settings {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.sidebar-settings-btn {\n  border: none;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 0;\n}\n\n.sidebar-settings-btn:hover {\n  color: #4b5563;\n}\n\n.dark .sidebar-settings-btn {\n  color: #9ca3af;\n}\n\n.dark .sidebar-settings-btn:hover {\n  color: #f9fafb;\n}\n\n.sidebar-settings-btn svg {\n  display: block;\n}\n\n.sidebar-settings-dropdown {\n  top: calc(100% + 0.5rem);\n  right: 0;\n  min-width: 190px;\n  z-index: 20;\n}\n\n.sidebar-settings-dropdown .menu-note {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin: 0.35rem 0 0;\n  line-height: 1.3;\n}\n\n.dark .sidebar-settings-dropdown .menu-note {\n  color: #d1d5db;\n}\n\n.client-selector {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 1.5rem var(--app-sidebar-content-padding-inline, 1.25rem);\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.client-selector--with-lecture {\n  flex: 1 1 auto;\n}\n\n.selector-label {\n  display: block;\n  width: 100%;\n  font-size: 1.09rem;\n  font-weight: 700;\n  color: #1f2937;\n  text-align: center;\n}\n\n.App-layout:not(.single-column-layout) > .client-sidebar .selector-label {\n  width: 100%;\n  align-self: center;\n  text-align: center;\n}\n\n.dark .selector-label {\n  color: #f9fafb;\n}\n\n.selector-description {\n  font-size: 0.86rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #6b7280;\n  text-align: center;\n  margin: 0;\n}\n\n.dark .selector-description {\n  color: #9ca3af;\n}\n\n.client-wheel-picker {\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) var(--app-wheel-control-width, 80px);\n  row-gap: 1.25rem;\n  column-gap: 0.5rem;\n  padding-left: 0.25rem;\n  align-items: center;\n  position: relative;\n}\n\n.wheel-inline-row,\n.random-client-row,\n.custom-client-row {\n  display: contents;\n}\n\n.wheel-inline-label {\n  font-size: 0.98rem;\n  font-weight: 600;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.dark .wheel-inline-label {\n  color: #f9fafb;\n}\n\n.wheel-horizontal-control {\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.wheel-window {\n  position: relative;\n  width: var(--app-wheel-control-width, 80px);\n  height: var(--app-wheel-control-height, 40px);\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: var(--surface-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 1.85rem 0 0.25rem;\n  font-size: 1.03rem;\n  font-weight: 600;\n  color: #1f2937;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.wheel-window:focus-visible {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);\n}\n\n.client-selection-cue .wheel-window,\n.client-selection-cue .random-client-btn {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.client-selection-cue .wheel-window .wheel-scroll-track,\n.client-selection-cue .wheel-window .wheel-scroll-btn {\n  border-color: rgba(59, 130, 246, 0.46);\n  background: inherit;\n  color: #1d4ed8;\n}\n\n.client-selection-cue .wheel-window .wheel-scroll-btn:hover,\n.client-selection-cue .wheel-window .wheel-scroll-btn:focus-visible {\n  background: rgba(59, 130, 246, 0.22);\n  color: #1e3a8a;\n}\n\n.client-selection-cue .random-client-btn:hover {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.5),\n    0 0 38px rgba(59, 130, 246, 0.9);\n}\n\n.client-selection-cue .oars-dropdown-trigger:hover {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.dark .wheel-window {\n  border-color: #4b5563;\n  background: #374151;\n  color: #f9fafb;\n}\n\n.dark .client-selection-cue .wheel-window,\n.dark .client-selection-cue .random-client-btn {\n  border-color: #60a5fa;\n  background: #1e3a5f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.dark .client-selection-cue .wheel-window .wheel-scroll-track,\n.dark .client-selection-cue .wheel-window .wheel-scroll-btn {\n  border-color: rgba(147, 197, 253, 0.42);\n  background: inherit;\n  color: #dbeafe;\n}\n\n.dark .client-selection-cue .wheel-window .wheel-scroll-btn:hover,\n.dark .client-selection-cue .wheel-window .wheel-scroll-btn:focus-visible {\n  background: rgba(147, 197, 253, 0.18);\n  color: #eff6ff;\n}\n\n.dark .client-selection-cue .random-client-btn:hover {\n  border-color: #93c5fd;\n  background: #23466f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.38),\n    0 0 34px rgba(96, 165, 250, 0.54);\n}\n\n.dark .client-selection-cue .oars-dropdown-trigger:hover {\n  border-color: #93c5fd;\n  background: #23466f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.client-selection-cue .oars-dropdown-trigger,\n.dark .client-selection-cue .oars-dropdown-trigger {\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.dark .client-selection-cue .oars-dropdown-trigger {\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.wheel-window-number {\n  line-height: 1;\n  flex: 1;\n  text-align: center;\n}\n\n.wheel-scroll-track {\n  position: absolute;\n  top: 1px;\n  right: 1px;\n  bottom: 1px;\n  width: 32px;\n  border-left: 1px solid #e5e7eb;\n  background: var(--surface-color);\n  border-radius: 0 7px 7px 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.wheel-scroll-btn {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: #4b5563;\n  font-size: 0.8rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  min-height: 50%;\n}\n\n.wheel-scroll-icon {\n  width: 11px;\n  height: 11px;\n}\n\n.wheel-scroll-btn:first-child::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 6px;\n  right: 6px;\n  height: 1px;\n  background: rgba(209, 213, 219, 0.8);\n}\n\n.wheel-scroll-btn:hover {\n  background: rgba(59, 130, 246, 0.1);\n  color: #1f2937;\n}\n\n.wheel-scroll-btn:focus-visible {\n  outline: none;\n  background: rgba(59, 130, 246, 0.18);\n  color: #1f2937;\n}\n\n.dark .wheel-scroll-track {\n  border-left-color: #4b5563;\n  background: #374151;\n}\n\n.dark .wheel-scroll-btn {\n  color: #d1d5db;\n}\n\n.dark .wheel-scroll-btn:first-child::after {\n  background: rgba(75, 85, 99, 0.85);\n}\n\n.dark .wheel-scroll-btn:hover,\n.dark .wheel-scroll-btn:focus-visible {\n  background: rgba(96, 165, 250, 0.18);\n  color: #f9fafb;\n}\n\n.random-client-btn {\n  flex: 0 0 auto;\n  display: flex;\n  width: var(--app-wheel-control-width, 80px);\n  height: var(--app-wheel-control-height, 40px);\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: var(--surface-color);\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;\n  position: relative;\n}\n\n.random-client-btn:hover {\n  border-color: #d1d5db;\n  background-color: #f9fafb;\n}\n\n.random-client-btn:active {\n  transform: scale(0.98);\n}\n\n.random-client-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.dark .random-client-btn {\n  border-color: #4b5563;\n  background-color: #374151;\n  color: #f9fafb;\n}\n\n.dark .random-client-btn:hover {\n  border-color: #6b7280;\n  background-color: #4b5563;\n}\n\n.dark .random-client-btn:disabled {\n  background-color: #111827;\n}\n\n.dice-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.random-client-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(59, 130, 246, 0.4);\n  border-top-color: rgba(59, 130, 246, 0.95);\n  border-radius: 50%;\n  animation: random-spin 0.7s linear infinite;\n}\n\n@keyframes random-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.custom-client-btn {\n  flex: 0 0 auto;\n  display: flex;\n  width: var(--app-wheel-control-width, 80px);\n  height: var(--app-wheel-control-height, 40px);\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: var(--surface-color);\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;\n  position: relative;\n}\n\n.custom-client-btn:hover {\n  border-color: #d1d5db;\n  background-color: #f9fafb;\n}\n\n.custom-client-btn:active {\n  transform: scale(0.98);\n}\n\n.dark .custom-client-btn {\n  border-color: #4b5563;\n  background-color: #374151;\n  color: #f9fafb;\n}\n\n.dark .custom-client-btn:hover {\n  border-color: #6b7280;\n  background-color: #4b5563;\n}\n\n.upload-icon {\n  width: 24px;\n  height: 24px;\n}\n\n\n.oars-sidebar-filters {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 1.5rem var(--app-sidebar-content-padding-inline, 1.25rem);\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.oars-sidebar-controls {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.client-sidebar--single-column-drawer {\n  --app-wheel-control-width: 72px;\n  --app-wheel-control-height: 36px;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  max-height: none;\n  overflow: visible;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  overscroll-behavior: contain;\n}\n\n.client-sidebar--single-column-drawer .client-selector,\n.client-sidebar--single-column-drawer .oars-sidebar-filters {\n  flex: 0 0 auto;\n  padding: 0;\n  margin-top: 0;\n  gap: 0.48rem;\n  align-items: stretch;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-filters {\n  flex: 1 1 auto;\n  min-height: 0;\n  gap: 0;\n  overflow: visible;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-controls {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding-bottom: 0.42rem;\n}\n\n.client-sidebar--single-column-drawer .selector-label {\n  width: auto;\n  font-size: 1rem;\n  line-height: 1.18;\n  text-align: left;\n  align-self: flex-start;\n}\n\n.client-sidebar--single-column-drawer .client-wheel-picker {\n  padding-left: 0;\n  column-gap: 0.55rem;\n  row-gap: 0.5rem;\n}\n\n.client-sidebar--single-column-drawer .wheel-inline-label {\n  font-size: 0.9rem;\n}\n\n.client-sidebar--single-column-drawer .wheel-window {\n  padding-right: 1.62rem;\n  font-size: 0.95rem;\n}\n\n.client-sidebar--single-column-drawer .wheel-scroll-track {\n  width: 28px;\n}\n\n.client-sidebar--single-column-drawer .dice-icon,\n.client-sidebar--single-column-drawer .upload-icon {\n  width: 21px;\n  height: 21px;\n}\n\n.client-sidebar--single-column-drawer .wheel-horizontal-control {\n  justify-content: flex-end;\n}\n\n/* Bound the selector column so the observer stack gets a definite height to\n   distribute — without it the tabs size to content and the whole stack scrolls. */\n.client-sidebar--single-column-drawer .client-selector:has(.single-column-observer-tabs) {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tabs {\n  --single-column-observer-inline-padding: 1.05rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  margin-top: 0;\n  margin-left: calc(-1 * var(--single-column-observer-inline-padding));\n  margin-right: calc(-1 * var(--single-column-observer-inline-padding));\n  padding: 0.62rem var(--single-column-observer-inline-padding) 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.72rem;\n  width: calc(100% + (2 * var(--single-column-observer-inline-padding)));\n  box-sizing: border-box;\n  overflow: hidden;\n  overscroll-behavior: contain;\n}\n\n/* Tabs keep overflow visible so the full-bleed divider below is not clipped;\n   the analytics shell clips its own body and scrolls internally instead. */\n.client-sidebar--single-column-drawer .single-column-observer-tab {\n  flex: 0 0 auto;\n  min-height: 0;\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab--analytics:not(.single-column-observer-tab--collapsed) {\n  flex: 1 1 auto;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab + .single-column-observer-tab {\n  position: relative;\n  padding-top: 0.72rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab + .single-column-observer-tab::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: calc(-1 * var(--single-column-observer-inline-padding));\n  right: calc(-1 * var(--single-column-observer-inline-padding));\n  border-top: 1px solid rgba(148, 163, 184, 0.25);\n}\n\n.dark .client-sidebar--single-column-drawer .single-column-observer-tab + .single-column-observer-tab::before {\n  border-top-color: rgba(75, 85, 99, 0.55);\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .wai-section,\n.client-sidebar--single-column-drawer .single-column-observer-tab .in-session-analytics {\n  height: auto;\n  min-height: 0;\n  margin-bottom: 0;\n  padding: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .wai-section {\n  flex: 0 0 auto;\n}\n\n/* Centre the chevron on the title row instead of baseline-aligning it to the\n   \"Latest\" value, matching the 3-column observer tab headers. */\n.client-sidebar--single-column-drawer .single-column-observer-tab .wai-panel__header {\n  align-items: center;\n  min-height: 24px;\n}\n\n/* Collapsed, the header has nothing below it to separate from, so its bottom\n   margin just pads the tab out past the divider. */\n.client-sidebar--single-column-drawer .single-column-observer-tab--collapsed .wai-panel__header {\n  margin-bottom: 0;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .in-session-analytics {\n  flex: 1 1 auto;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .wai-chart {\n  max-height: 13rem;\n  overflow: hidden;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .wai-chart__svg {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-scroll-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-sections {\n  gap: 0.72rem;\n  width: 100%;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-card {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-card-header {\n  padding: 0.52rem 0.72rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-observer-tab .analytics-card-content {\n  padding: 0.62rem 0.72rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics {\n  flex: 1 1 auto;\n  min-height: 0;\n  margin-top: 0.72rem;\n  padding-top: 0.72rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: visible;\n}\n\n/* The analytics review nests the observer stack, which brings its own top\n   padding — drop the metrics wrapper's so the WAI tab sits where it does\n   during a live session. */\n.client-sidebar--single-column-drawer .single-column-session-metrics--analytics {\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.72rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-end-reason {\n  border: 1px solid #d1d5db;\n  border-radius: 0.65rem;\n  padding: 0.72rem 0.82rem;\n  background: rgba(255, 255, 255, 0.42);\n}\n\n.dark .client-sidebar--single-column-drawer .single-column-session-end-reason {\n  background: rgba(15, 23, 42, 0.22);\n  border-color: rgba(75, 85, 99, 0.75);\n}\n\n.client-sidebar--single-column-drawer .single-column-session-end-reason__label {\n  display: block;\n  color: #6b7280;\n  font-size: 0.73rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.dark .client-sidebar--single-column-drawer .single-column-session-end-reason__label {\n  color: #9ca3af;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-end-reason__text {\n  margin: 0.38rem 0 0;\n  color: #1f2937;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  text-align: center;\n}\n\n.dark .client-sidebar--single-column-drawer .single-column-session-end-reason__text {\n  color: #e5e7eb;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics .download-row {\n  margin-top: 0;\n  padding: 0.52rem 0.55rem;\n  gap: 0.28rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics .download-row-inner {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.28rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics .download-action-item {\n  gap: 0.25rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics .download-label {\n  font-size: 0.74rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-metrics .download-icon-button {\n  width: 1.82rem;\n  height: 1.82rem;\n}\n\n.client-sidebar--single-column-drawer .single-column-session-action-dock {\n  flex: 0 0 auto;\n  position: relative;\n  margin: auto -1.05rem -0.75rem;\n  padding: 0.95rem 1.05rem 0.75rem;\n  background: var(--surface-panel-color);\n}\n\n.client-sidebar--single-column-drawer .single-column-session-action-dock::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid rgba(148, 163, 184, 0.25);\n}\n\n.dark .client-sidebar--single-column-drawer .single-column-session-action-dock {\n  background: #1c2630;\n}\n\n.dark .client-sidebar--single-column-drawer .single-column-session-action-dock::before {\n  border-top-color: rgba(75, 85, 99, 0.55);\n}\n\n.client-sidebar--single-column-drawer .sidebar-lecture-video {\n  display: none;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-context-panel {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 0.45rem 0 0;\n  margin-top: 0.35rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-context-panel::-webkit-scrollbar {\n  display: none;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-context-panel .analytics-header {\n  margin-bottom: 0.25rem;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-context-body {\n  font-size: 0.86rem;\n  line-height: 1.65;\n  color: #374151;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.dark .client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-context-body {\n  color: #d1d5db;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-action-bar {\n  margin-top: 0.35rem;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-context-panel .oars-next-exercise-wrap {\n  width: min(13rem, 100%);\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n  padding-top: 0.85rem;\n  padding-bottom: 0.9rem;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-divider {\n  flex: 0 0 auto;\n  height: 0;\n  margin: 0 -1.05rem;\n  border-top: 1px solid transparent;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-divider--visible {\n  border-top-color: rgba(148, 163, 184, 0.25);\n}\n\n.dark .client-sidebar--single-column-drawer .oars-sidebar-feedback-divider--visible {\n  border-top-color: rgba(75, 85, 99, 0.55);\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-card-content {\n  min-height: 0;\n  padding: 0.6rem 0.75rem 0.7rem;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-card-header {\n  padding: 0.42rem 0.75rem;\n}\n\n.oars-guidance-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  margin-left: auto;\n}\n\n.oars-guidance-expand-btn {\n  display: none;\n}\n\n.client-sidebar--single-column-drawer .oars-guidance-expand-btn {\n  display: inline-flex;\n}\n\n.client-sidebar--single-column-drawer .oars-guidance-expand-btn--selection-cue {\n  color: #2563eb;\n  filter:\n    drop-shadow(0 0 4px rgba(59, 130, 246, 1))\n    drop-shadow(0 0 14px rgba(59, 130, 246, 0.84))\n    drop-shadow(0 0 24px rgba(59, 130, 246, 0.5));\n}\n\n.dark .client-sidebar--single-column-drawer .oars-guidance-expand-btn--selection-cue {\n  color: #93c5fd;\n  filter:\n    drop-shadow(0 0 4px rgba(96, 165, 250, 1))\n    drop-shadow(0 0 14px rgba(96, 165, 250, 0.78))\n    drop-shadow(0 0 24px rgba(96, 165, 250, 0.48));\n}\n\n.oars-guidance-expanded-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 0 0 auto;\n  min-height: 3.35rem;\n  padding: 0.85rem 3.25rem 0.85rem 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.dark .oars-guidance-expanded-header {\n  border-bottom-color: #374151;\n}\n\n.oars-guidance-expanded-header h3 {\n  margin: 0;\n  color: #111827;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.dark .oars-guidance-expanded-header h3 {\n  color: #f9fafb;\n}\n\n.oars-guidance-expanded-close {\n  top: 0.8rem;\n  right: 0.8rem;\n}\n\n.oars-guidance-expanded-body {\n  white-space: pre-wrap;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-text {\n  display: block;\n  line-height: 1.55;\n  white-space: pre-wrap;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-scroll .analytics-sections {\n  gap: 0.75rem;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-feedback-tail {\n  flex: 0 0 0.15rem;\n  min-height: 0.15rem;\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-action-dock {\n  flex: 0 0 auto;\n  position: relative;\n  margin: 0 -1.05rem -0.75rem;\n  padding: 0.95rem 1.05rem 0.75rem;\n  background: var(--surface-panel-color);\n}\n\n.client-sidebar--single-column-drawer .oars-sidebar-action-dock::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  border-top: 1px solid rgba(148, 163, 184, 0.25);\n}\n\n.dark .client-sidebar--single-column-drawer .oars-sidebar-action-dock {\n  background: #1c2630;\n}\n\n.dark .client-sidebar--single-column-drawer .oars-sidebar-action-dock::before {\n  border-top-color: rgba(75, 85, 99, 0.55);\n}\n\n.sidebar-lecture-video {\n  margin-top: auto;\n  padding-top: 0.5rem;\n}\n\n.App-layout.single-column-layout .sidebar-lecture-video {\n  display: none;\n}\n\n.sidebar-lecture-video-label {\n  text-align: left;\n  margin-bottom: 0.75rem;\n}\n\n.sidebar-lecture-video-frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #000;\n  display: block;\n  border: 1px solid #e5e7eb;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  padding: 0;\n  cursor: pointer;\n}\n\n.sidebar-lecture-video-frame::after {\n  content: '▶';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.9);\n  width: 56px;\n  height: 56px;\n  border-radius: 999px;\n  background: rgba(248, 250, 252, 0.92);\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  color: #1f2937;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  line-height: 1;\n  opacity: 0;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.16);\n  transition: opacity 0.2s ease, transform 0.2s ease, background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n  pointer-events: none;\n}\n\n.sidebar-lecture-video-frame:hover {\n  border-color: #d1d5db;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);\n}\n\n.sidebar-lecture-video-frame:hover::after,\n.sidebar-lecture-video-frame:focus-visible::after {\n  opacity: 1;\n  transform: translate(-50%, -50%) scale(1);\n}\n\n.dark .sidebar-lecture-video-frame {\n  border-color: #4b5563;\n}\n\n.dark .sidebar-lecture-video-frame::after {\n  background: rgba(28, 38, 48, 0.92);\n  border-color: rgba(75, 85, 99, 0.85);\n  color: #f8fafc;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n.dark .sidebar-lecture-video-frame:hover {\n  border-color: #6b7280;\n  box-shadow: 0 10px 24px rgba(2, 6, 23, 0.3);\n}\n\n.sidebar-lecture-video-frame img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.sidebar-lecture-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 60000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba(15, 23, 42, 0.6);\n}\n\n.sidebar-lecture-modal-panel {\n  width: min(960px, 100%);\n  background: var(--surface-color);\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 12px;\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.32);\n  overflow: hidden;\n}\n\n.sidebar-lecture-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem 1.25rem;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.3);\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n.sidebar-lecture-modal-header.is-dragging { cursor: grabbing; }\n\n.sidebar-lecture-modal-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  color: #111827;\n}\n\n.sidebar-lecture-modal-close {\n  width: 1.75rem;\n  height: 1.75rem;\n  border: none;\n  padding: 0;\n  background: transparent;\n  color: #9ca3af;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: color 0.15s;\n}\n\n.sidebar-lecture-modal-close:hover {\n  color: #374151;\n}\n\n.sidebar-lecture-modal-close svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.sidebar-lecture-modal-video {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  background: #000;\n}\n\n.sidebar-lecture-modal-video iframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n}\n\n.dark .sidebar-lecture-modal-panel {\n  background: #1c2630;\n  border-color: #263447;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5);\n}\n\n.dark .sidebar-lecture-modal-header {\n  border-bottom-color: rgba(75, 85, 99, 0.6);\n}\n\n.dark .sidebar-lecture-modal-header h3 {\n  color: #f9fafb;\n}\n\n.dark .sidebar-lecture-modal-close {\n  background: transparent;\n  color: #6b7280;\n}\n\n.dark .sidebar-lecture-modal-close:hover {\n  background: transparent;\n  color: #e5e7eb;\n}\n\n.oars-skill-dropdown {\n  position: relative;\n}\n\n.oars-dropdown-trigger {\n  cursor: pointer;\n  user-select: none;\n}\n\n.oars-dropdown-trigger:hover {\n  border-color: #d1d5db;\n}\n\n.dark .oars-dropdown-trigger:hover {\n  border-color: #6b7280;\n  background-color: #4b5563;\n}\n\n.oars-dropdown-trigger.open,\n.oars-dropdown-trigger:focus-visible {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: none;\n}\n\n.dark .oars-dropdown-trigger.open,\n.dark .oars-dropdown-trigger:focus-visible {\n  border-color: #3b82f6;\n  box-shadow: none;\n}\n\n.oars-dropdown-arrow {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #4b5563;\n  pointer-events: none;\n}\n\n.dark .oars-dropdown-arrow {\n  color: #d1d5db;\n}\n\n.oars-skill-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  min-width: 170px;\n  background: var(--surface-color);\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  z-index: 50;\n  overflow: hidden;\n  padding: 0.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.dark .oars-skill-dropdown-menu {\n  background: #1f2937;\n  border-color: #374151;\n}\n\n.oars-skill-dropdown-option {\n  width: 100%;\n  padding: 0.45rem 0.65rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #374151;\n  font-size: 0.8rem;\n  font-weight: 500;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n}\n\n.oars-skill-dropdown-option:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.oars-skill-dropdown-option.selected {\n  background: rgba(37, 99, 235, 0.08);\n  color: #2563eb;\n  font-weight: 600;\n}\n\n\n.dark .oars-skill-dropdown-option {\n  color: #d1d5db;\n}\n\n.dark .oars-skill-dropdown-option:hover {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.dark .oars-skill-dropdown-option.selected {\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n}\n\n\n.oars-skill-dropdown-option-letter {\n  font-weight: 700;\n  width: 1rem;\n  flex-shrink: 0;\n  color: #9ca3af;\n}\n\n.oars-skill-dropdown-option.selected .oars-skill-dropdown-option-letter {\n  color: inherit;\n}\n\n.btc-counsellor-dropdown-menu .oars-skill-dropdown-option {\n  gap: 0.55rem;\n}\n\n.btc-counsellor-dropdown-menu .oars-skill-dropdown-option-letter {\n  width: 2.15rem;\n}\n\n\n.sidebar-loading,\n.sidebar-error {\n  padding: 2rem 1rem;\n  text-align: center;\n  color: #6e6e80;\n}\n\n.sidebar-error button {\n  margin-top: 0.5rem;\n  padding: 0.5rem 1rem;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.sidebar-error button:hover {\n  background-color: #2980b9;\n}\n\n@media (max-width: 768px) {\n  .client-sidebar {\n    background: rgba(255, 255, 255, 0.5);\n    border-radius: 12px;\n    height: auto;\n    max-height: none;\n    padding: 0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    overflow: visible;\n  }\n\n  .dark .client-sidebar {\n    background: rgba(31, 41, 55, 0.5);\n  }\n\n  .client-sidebar.client-sidebar--single-column-drawer {\n    background: transparent;\n    border-radius: 0;\n    height: 100%;\n    min-height: 0;\n    max-height: none;\n    overflow: visible;\n    box-shadow: none;\n  }\n\n  .dark .client-sidebar.client-sidebar--single-column-drawer {\n    background: transparent;\n  }\n\n  .client-sidebar.collapsed {\n    min-width: auto;\n    max-width: none;\n  }\n\n  .sidebar-header {\n    padding: 0.75rem 1rem;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
